module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-Kreis_black-dcb11090771e381754dc239a2fff5b43.svg";